import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon_01 from '../../Assets/icon/services-icon/Asset 4.png';
import Icon_02 from '../../Assets/icon/services-icon/Asset 5.png';
import Icon_03 from '../../Assets/icon/services-icon/Asset 6.png';
import Icon_04 from '../../Assets/icon/services-icon/Asset 7.png';
import Icon_05 from '../../Assets/icon/services-icon/Asset 8.png';
import Icon_06 from '../../Assets/icon/services-icon/Asset 9.png';
import Icon_07 from '../../Assets/icon/services-icon/Asset 10.png';
import Icon_08 from '../../Assets/icon/services-icon/Asset 11.png';
import Icon_09 from '../../Assets/icon/services-icon/Asset 13.png';
import Icon_10 from '../../Assets/icon/services-icon/Asset 14.png';
import Icon_11 from '../../Assets/icon/services-icon/Asset 15.png';

const TenderwiseServices = () => {
  const [searchInput, setSearchInput] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    if (searchInput) {
      navigate('/limitedTenderView', { state: { searchTerm: searchInput } });
    }
  }, [searchInput, navigate]); // Depend on searchInput and navigate

  const services = [
    {
      id: 1,
      icon: <img src={Icon_01} alt="Logo" className="h-12 w-12" />,
      title: 'Free Tender Viewing',
      text: 'Access all available tenders without any cost',
      path: '/allTenders',
    },
    {
      id: 2,
      icon: <img src={Icon_10} alt="Logo" className="h-12 w-12" />,
      title: 'Package Purchase',
      text: 'Buy tender packages that suit your business needs.',
      path: '/pricingPackages',
    },
    {
      id: 3,
      icon: <img src={Icon_03} alt="Logo" className="h-12 w-12" />,
      title: 'Government Tenders (e-GP)',
      text: 'Stay updated with all government tender opportunities.',
      path: '',
      onClick: () => {
        setSearchInput('govt');
        
      }
    },

    {
      id: 4,
      icon: <img src={Icon_09} alt="Logo" className="h-12 w-12" />,
      title: 'Newspaper Tenders',
      text: 'Browse tenders published in newspapers',
      path: '',
      onClick: () => {
        setSearchInput('Newspaper');
        
      }
    },
    {
      id: 7,
      icon: <img src={Icon_11} alt="Logo" className="h-12 w-12" />,
      title: 'All Advertisement Tender',
      text: 'Explore tender from private organizations.',
      path: '',
      onClick: () => {
        setSearchInput('Advertisement');
        
      }
    },
    {
      id: 8,
      icon: <img src={Icon_06} alt="Logo" className="h-12 w-12" />,
      title: 'Private Company Tender',
      text: 'Explore Tender From Private organizations.',
      path: '',
      onClick: () => {
        setSearchInput('Private');
        
      }
    },
    {
      id: 5,
      icon: <img src={Icon_02} alt="Logo" className="h-12 w-12" />,
      title: 'Advanced Tender Search',
      text: 'Find tenders by category, department, Upazila, and source.',
      path: '',
    },
    {
      id: 6,
      icon: <img src={Icon_04} alt="Logo" className="h-12 w-12" />,
      title: 'Regular Tenders Alert',
      text: 'Stay Updated with Regular Tenders Alert!',
      path: '',
    },

    {
      id: 9,
      icon: <img src={Icon_07} alt="Logo" className="h-12 w-12" />,
      title: 'Tender Publishing Request',
      text: 'Submit request to publish your tenders on our platform.',
      path: '/tenderpublish',
    },

    {
      id: 10,
      icon: <img src={Icon_08} alt="Logo" className="h-12 w-12" />,
      title: 'Published Tender Management',
      text: 'Publish tenders, view all your published tenders',
      path: '',
    },
    {
      id: 11,
      icon: <img src={Icon_11} alt="Logo" className="h-12 w-12" />,
      title: 'Simple & Easy Dashboard',
      text: 'Manage all your tender-related tasks from a single dashboard.',
      path: '/dashboard',
    },
    {
      id: 12,
      icon: <img src={Icon_05} alt="Logo" className="h-12 w-12" />,
      title: 'Associate Profile Management',
      text: 'Add and manage your department, company, and client accounts.',
      path: '/associate-profile-management',
    },
  ];



  return (
    <div id="services" className="w-full bg-white container mx-auto">
      <div className="px-2 py-4 mb-10">
        <div className="text-center">
          <h2 className="md:text-2xl text-xl font-bold text-gray-800 mb-8">
            Our <span className="text-ServiceIconColor">Services</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map(service => (
            <div
              key={service.id}
              onClick={() => {
                if (service.onClick) {
                  service.onClick();  // Custom onClick handler call
                } else {
                  navigate(service.path);  // Navigate to the path
                  window.scrollTo(0, 0);    // Scroll to the top of the page
                }
              }}
              className="bg-white p-4 rounded-xl shadow-orange-200 hover:shadow-xl transition-shadow duration-300 border-2 border-gray-300 cursor-pointer"
            >
              <div className="flex flex-col items-center text-center">
                <div>{service.icon}</div>
                <h3 className="md:text-xl text-lg font-semibold text-gray-800 mb-2 mt-1">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-xs md:text-sm">
                  {service.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

  );
};

export default TenderwiseServices;

// import React from 'react';
// import Icon_01 from '../../Assets/icon/services-icon/Asset 4.png';
// import Icon_02 from '../../Assets/icon/services-icon/Asset 5.png';
// import Icon_03 from '../../Assets/icon/services-icon/Asset 6.png';
// import Icon_04 from '../../Assets/icon/services-icon/Asset 7.png';
// import Icon_05 from '../../Assets/icon/services-icon/Asset 8.png';
// import Icon_06 from '../../Assets/icon/services-icon/Asset 9.png';
// import Icon_07 from '../../Assets/icon/services-icon/Asset 10.png';
// import Icon_08 from '../../Assets/icon/services-icon/Asset 11.png';
// import Icon_09 from '../../Assets/icon/services-icon/Asset 13.png';
// import Icon_10 from '../../Assets/icon/services-icon/Asset 14.png';
// import Icon_11 from '../../Assets/icon/services-icon/Asset 15.png';
// const TenderwiseServices = () => {

//   const services = [
//    {
//   id: 1,
//   icon: <img src={Icon_01} alt="Logo" className="h-12 w-12" />,
//   title:'Free Tender Viewing',
//   text: 'Access all available tenders without any cost',
// },
//     {
//       id: 2,
//       icon: <img src={Icon_02} alt="Logo" className="h-12 w-12" />,
//       title: 'Advanced Tender Search',
//       text: 'Find tenders by category, department,Upazila,and source.',
//     },
//     {
//       id: 3,
//       icon: <img src={Icon_03} alt="Logo" className="h-12 w-12" />,
//       title: 'Government Tenders (e-GP)',
//       text: 'Stay updated with all government tender opportunities.',
//     },
//     {
//       id: 4,
//       icon: <img src={Icon_04} alt="Logo" className="h-12 w-12" />,
//       title: 'Regular Tenders Alert',
//       text: 'Stay Updated with Regular Tenders Alert!',
//     },
//     {
//       id: 5,
//       icon: <img src={Icon_05} alt="Logo" className="h-12 w-12" />,
//       title: 'Associate Profile Management',
//       text: 'Add and manage your department, company,and client accounts.',
//     },
//     {
//       id: 6,
//       icon: <img src={Icon_06} alt="Logo" className="h-12 w-12" />,
//       title: 'Private Company Tender',
//       text: 'Explore Tender From Private organizations.',
//     },
//     {
//       id: 7,
//       icon: <img src={Icon_07} alt="Logo" className="h-12 w-12" />,
//       title: 'Tender Publishing Request',
//       text: 'Submit request to publish your tenders on our platform.',
//     },
//     {
//       id: 8,
//       icon: <img src={Icon_08} alt="Logo" className="h-12 w-12" />,
//       title: 'Published Tender Management',
//       text: 'Publish tenders, view all your published tenders',
//     },
//     {
//       id: 9,
//       icon: <img src={Icon_09} alt="Logo" className="h-12 w-12" />,
//       title: 'Newspaper Tenders',
//       text: 'Browse tenders published in newspapers ',
//     },
//     {
//       id: 10,
//       icon: <img src={Icon_10} alt="Logo" className="h-12 w-12" />,
//       title: 'Package Purchase',
//       text: 'Buy tender packages that suit your business needs.',
//     },
//     {
//       id: 11,
//       icon: <img src={Icon_11} alt="Logo" className="h-12 w-12" />,
//       title: 'Simple & Easy Dashboard',
//       text: 'Manage All Your Tender Related Tasks From a Single Dashboard',
//     },
//     {
//       id: 12,
//       icon: <img src={Icon_11} alt="Logo" className="h-12 w-12" />,
//       title: 'All Advertisement Tender',
//       text: 'Explore tender from private organizations.',
//     },
//   ];
//   return (
//     <div id="services" className="w-full bg-white container mx-auto ">
//       <div className="px-2 py-4 mb-10">
//         <div className="text-center">
//           <h2 className="md:text-2xl text-xl font-bold  text-gray-800 mb-8">
//             Our <span className="text-ServiceIconColor">Services</span>
//           </h2>
//           {/* <p className="md:mb-8 mb-3 md:text-lg text-sm">
//                 Explore the range of loan options and financial solutions we
//                 offer to meet your needs.
//               </p> */}
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//           {services.map(services => (
//             <div
//               key={services.id}
//               className="bg-white p-4 rounded-xl shadow-orange-200 hover:shadow-xl  transition-shadow duration-300 border-2 border-gray-300 cursor-pointer"
//             >
//               <div className="flex flex-col items-center text-center">
//                 <div>{services.icon}</div>
//                 <h3 className="md:text-xl text-lg font-semibold text-gray-800 mb-2 mt-1">
//                   {services.title}
//                 </h3>
//                 <p className="text-gray-600 text-xs md:text-sm">
//                   {services.text}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TenderwiseServices;
